import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Grid, Link, Breadcrumbs as MuiBreadcrumbs, Typography } from '@mui/material'
import { spacing } from '@mui/system'
import { styled } from '@mui/material/styles'
import RuuviTagScroller from '../../components/RuuviTagScroller'
import PageHeader from '../../components/PageHeader'

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing)

export default function RuuviTagsPage() {
  /**
   * The translate function.
   */
  const [t] = useTranslation('common')

  return (
    <>
      <PageHeader
        title={t('conditionMonitoring')}
        breadcrumbs={
          <Breadcrumbs>
            <Link component={NavLink} to="/">
              {t('frontpage')}
            </Link>
            <Typography>{t('conditionMonitoring')}</Typography>
          </Breadcrumbs>
        }
      />

      <Grid container spacing={6} sx={{ height: 'calc(100% - 32px)' }}>
        <Grid item xs={12} sx={{ height: '100%' }}>
          <RuuviTagScroller />
        </Grid>
      </Grid>
    </>
  )
}
